var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = x({ ["Probot"]: () => __WEBPACK_EXTERNAL_MODULE_probot__.Probot, ["Server"]: () => __WEBPACK_EXTERNAL_MODULE_probot__.Server });